import { memo } from "react";
import * as React from "react";
import { Paper, Stack, Typography } from "@mui/material";
import { getAllResources } from "../request/get-all-resources";
import { ResourcesLayout } from "./resources-layout";
export const AllResourcesLayout = memo(() => {
    const [allResources, setAllResources] = React.useState([]);
    React.useEffect(() => {
        getAllResources()
            .then((resources) => {
            setAllResources(resources);
        })
            .catch((error) => {
            console.error("Error fetching resources:", error);
        });
    }, []);
    return (React.createElement(Paper, { elevation: 3, style: {
            padding: "16px",
            flex: 1,
            overflow: "auto",
            width: "100%",
        } },
        React.createElement(Stack, { direction: "column", spacing: 2 },
            React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center" },
                React.createElement(Typography, { variant: "h4" }, "All Resources")),
            React.createElement(ResourcesLayout, { resources: allResources }))));
});
AllResourcesLayout.displayName = "AllResourcesLayout";
